import * as bootstrap from 'bootstrap';
import "./index.scss"

// Custom JS
import "./spinner.js"
import "./dropdown-submenu.js"
import "./sidemenu.js"
import "./inline-edit.js"
import "./subtab-nav.js"

window.bootstrap = bootstrap;
window.showSpinner = showSpinner;
